import { CaretRight } from "@phosphor-icons/react";
import { Text } from "@radix-ui/themes";
import { useState } from "react";

import { CanvasBlockRenderer } from "../CanvasBlockRenderer";
import { type CanvasBlock } from "../types";

interface ExpandableBlockProps {
  title: string;
  summary?: string;
  children: CanvasBlock[];
}

export function ExpandableBlock({
  title,
  summary,
  children,
}: ExpandableBlockProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="rounded-xl border border-puntt-neutral-gray-5 shadow-sm">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex w-full items-center gap-2 px-4 py-2.5 text-left transition-colors hover:bg-puntt-neutral-gray-2"
      >
        <CaretRight
          size={14}
          className={`shrink-0 transition-transform duration-200 ${expanded ? "rotate-90" : ""}`}
        />
        <Text
          size="2"
          weight="medium"
          className="flex-1 text-puntt-neutral-gray-12"
        >
          {title}
        </Text>
        {!expanded && summary && (
          <Text size="1" className="text-puntt-neutral-gray-9">
            {summary}
          </Text>
        )}
      </button>
      <div
        className={`grid transition-all duration-300 ease-out ${
          expanded ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <div className="space-y-2 border-t border-puntt-neutral-gray-4 px-3 py-2">
            {children.map((child, idx) => (
              <CanvasBlockRenderer key={idx} block={child} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
